"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basketMutations = exports.basketMutationKeys = void 0;
const basket_api_1 = require("./basket.api");
exports.basketMutationKeys = {
    all: () => ['basket'],
    postSavePoint: () => [...exports.basketMutationKeys.all(), 'postSavePoint'],
    postCheckStockReservation: () => [...exports.basketMutationKeys.all(), 'postCheckStockReservation'],
    postSwitchFictiveWebshop: () => [...exports.basketMutationKeys.all(), 'postSwitchFictiveWebshop'],
    deleteVoucher: () => [...exports.basketMutationKeys.all(), 'deleteVoucher'],
    postVoucher: () => [...exports.basketMutationKeys.all(), 'postVoucher'],
};
const basketMutations = (apiOptions) => ({
    postSavePoint: {
        mutationKey: exports.basketMutationKeys.postSavePoint(),
        mutationFn: () => (0, basket_api_1.postSavePoint)(apiOptions),
    },
    postCheckStockReservation: {
        mutationKey: exports.basketMutationKeys.postCheckStockReservation(),
        mutationFn: () => (0, basket_api_1.postCheckStockReservation)(apiOptions),
    },
    postSwitchFictiveWebshop: {
        mutationKey: exports.basketMutationKeys.postSwitchFictiveWebshop(),
        mutationFn: () => (0, basket_api_1.postSwitchFictiveWebshop)(apiOptions),
    },
    deleteVoucher: {
        mutationKey: exports.basketMutationKeys.deleteVoucher(),
        mutationFn: (code) => (0, basket_api_1.deleteVoucher)(apiOptions, code),
    },
    postVoucher: {
        mutationKey: exports.basketMutationKeys.postVoucher(),
        mutationFn: (voucherData) => (0, basket_api_1.postVoucher)(apiOptions, voucherData),
    },
});
exports.basketMutations = basketMutations;
//# sourceMappingURL=basket.mutations.js.map